import FeedItemContainer from './containers/FeedItemContainer'

export default FeedItemContainer
